import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach token to every request if present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // Auth
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  verify2fa: (ticket, code) => client.post("/auth/2fa/verify", { ticket, code }).then((r) => r.data),
  changePassword: (current_password, new_password) => client.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
  twofaSetup: () => client.post("/auth/2fa/setup").then((r) => r.data),
  twofaEnable: (code) => client.post("/auth/2fa/enable", { code }).then((r) => r.data),
  twofaDisable: (code, password) => client.post("/auth/2fa/disable", { code, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  forgot: (email) => client.post("/auth/forgot", { email }).then((r) => r.data),
  reset: (token, password) => client.post("/auth/reset", { token, password }).then((r) => r.data),
  resetOtp: (email, code, password) => client.post("/auth/reset-otp", { email, code, password }).then((r) => r.data),
  acceptInvite: (token, password) => client.post("/auth/accept-invite", { token, password }).then((r) => r.data),
  inviteAgent: (email, permissions) => client.post("/auth/invite", { email, permissions }).then((r) => r.data),
  createAgent: (email, password, permissions) => client.post("/auth/agents", { email, password, permissions }).then((r) => r.data),
  updateAgent: (id, permissions) => client.patch(`/auth/agents/${id}`, { permissions }).then((r) => r.data),
  resetAgent: (id) => client.post(`/auth/agents/${id}/reset`).then((r) => r.data),
  listAgents: () => client.get("/auth/agents").then((r) => r.data),
  deleteAgent: (id) => client.delete(`/auth/agents/${id}`).then((r) => r.data),

  // Sites
  listSites: () => client.get("/sites").then((r) => r.data),
  getActiveSite: () => client.get("/sites/active").then((r) => r.data),
  createSite: (payload) => client.post("/sites", payload).then((r) => r.data),
  updateSite: (id, payload) => client.put(`/sites/${id}`, payload).then((r) => r.data),
  deleteSite: (id) => client.delete(`/sites/${id}`).then((r) => r.data),
  activateSite: (id) => client.patch(`/sites/${id}/activate`).then((r) => r.data),
  recordClick: (id) => client.post(`/sites/${id}/click`).then((r) => r.data),

  // Featured brands
  listBrands: () => client.get("/brands").then((r) => r.data),
  createBrand: (payload) => client.post("/brands", payload).then((r) => r.data),
  updateBrand: (id, payload) => client.put(`/brands/${id}`, payload).then((r) => r.data),
  deleteBrand: (id) => client.delete(`/brands/${id}`).then((r) => r.data),
  moveBrand: (id, direction) => client.patch(`/brands/${id}/move?direction=${direction}`).then((r) => r.data),
};

export default api;
